import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 会計処理 */
enum AccountingProcessing {
  leasingProcess = '1',
  saleAndPurchaseProcessing = '2',
}

const nameConfig = {
  leasingProcess: new Map([
    [Locale.ja, '賃貸借処理'],
    [Locale.en, 'Leasing Process'],
  ]),
  saleAndPurchaseProcessing: new Map([
    [Locale.ja, '売買処理'],
    [Locale.en, 'Sale and Purchase Processing'],
  ]),
};

const toEnum = rawValueToEnum(AccountingProcessing, AccountingProcessing.leasingProcess);
const toDisplay = enumToName(AccountingProcessing, nameConfig);
const toDisplayWithPrefix = enumToName(AccountingProcessing, nameConfig, { prefix: true });

export const accountingProcessing = {
  enum: AccountingProcessing,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { AccountingProcessing };
